import { render } from "./FlechasComponent.vue?vue&type=template&id=69c75586&scoped=true"
import script from "./FlechasComponent.vue?vue&type=script&lang=js"
export * from "./FlechasComponent.vue?vue&type=script&lang=js"

import "./FlechasComponent.vue?vue&type=style&index=0&id=69c75586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c75586"]])

export default __exports__